<div id="parentIdOfHtml" class="d-flex align-items-center navbar-width p-menubar py-0">
    <a class="navbar-brand d-flex align-items-center me-5 text-white" href="#"><img src="assets/images/ey-logo.svg"
            width="28" height="28" alt="Ey logo, lands to digital tax advisor page" />
        <span class="size">EY Global Tax E-Invoicing Solution</span>
    </a>
    <!-- <div class="d-flex justify-content-end ms-auto border-0 langnav">
        <a class="d-flex align-items-end text-white country-decoration">
            <img [src]="countryFlag" width="34" height="35" />
            <div class="ms-1 country-name">{{ selectedCountry }}</div>
        </a>
        <p-menubar class="'dropdown_ID'" [autoDisplay]="false" [model]="useritems"></p-menubar>
    </div> -->
</div>

<div id="container">
    <div class="d-flex justify-content-center" style="margin-top: 13vh;">
        <p-card [style]="{ 'width': '50vw', 'text-align': 'center' }">
            <h5 style="font-size: 1.5vw;">System Maintenance.</h5> <br>
            <p style="font-size: 1.15vw;" [innerHTML]="maintenanceMessage"></p>
        </p-card>
    </div>
    <footer>
        <div class="footer-content">
            <p>&copy; {{currentYear}} EYGM Limited. All Rights Reserved.</p>
        </div>
    </footer>
</div>